export default {
  homeTab: 'home'
}
